import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import {
  authService,
  routeDirectory,
  useDialogControl
} from 'modules';
import { useNavigate } from 'react-router-dom';

import * as dataService from './dataService';



export interface IProps {}

export const FC: React.FC<IProps> = props => {
  const control = useDialogControl({});
  const { mutations, loading } = dataService.useDeleteAccountModal();
  const navigate = useNavigate();



  return (
    <>
      <Button
        variant="outlined"
        color="error"
        onClick={control.openDialog}>
        Delete Account
      </Button>

      <Dialog
        open={control.isOpen}
        onClose={control.closeDialog}
        maxWidth="xs">
        <DialogTitle>Are you sure?</DialogTitle>

        <DialogContent>
          <Typography>
            This action will cancel your subscription before the next billing cycle and your account will be deleted.  Once you have deleted your account, you will not be able to retrieve it. Are you sure you want to complete this action?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            disabled={loading}
            variant="outlined"
            color="secondary"
            onClick={control.closeDialog}>
            Cancel
          </Button>

          <Button
            disabled={loading}
            onClick={async () => {
              await mutations.deleteLoggedInUser();
              await authService.logOut();
              navigate(routeDirectory.authentication.login.path());
            }}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
